import { Typography } from "@mui/material";
import React from "react";

export default function SectionHeading({ title }) {
  return (
    <div>
      <div class="head_title">
        <Typography variant="h1" className="section_heading heading_two">
          {title}
        </Typography>
        <div className="divider">
          <Typography variant="span" className="dot"></Typography>
          <Typography variant="span" className="hexagon"></Typography>
          <Typography variant="span" className="dot"></Typography>
        </div>
      </div>
    </div>
  );
}
